import { FC } from "react";
import { useMsal } from "@azure/msal-react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "hooks";
import {
  selectDrawerSelectedAccountId,
  selectSpecificObjectState
} from "app/data/selectors";
import { isMonitoringTabEnabled } from "app/data/helpers/monitoringAccess";
import { analyticsEnabled } from "app/data/services/AnalyticsSession";
import ObjectTabsLayout from "components/common/objects/ObjectTabsLayout/ObjectTabsLayout";
import GrafanaDashboard from "components/GrafanaDashboard/GrafanaDashboard";

const ObjectGrafana: FC = () => {
  const { instance } = useMsal();
  const userId = instance.getActiveAccount()?.homeAccountId ?? "";
  const accountId = useAppSelector(selectDrawerSelectedAccountId) || "";
  const { specificObject } = useAppSelector(selectSpecificObjectState);

  if (!analyticsEnabled || !isMonitoringTabEnabled(accountId))
    return <Navigate to="/dashboard/objects" replace />;

  return (
    <main>
      <ObjectTabsLayout>
        {specificObject?.uniqueId && (
          <GrafanaDashboard
            userId={userId}
            selectedTenantId={accountId}
            accountId={accountId}
            objectId={specificObject.uniqueId}
          />
        )}
      </ObjectTabsLayout>
    </main>
  );
};

export default ObjectGrafana;
